var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"toggle-pill"},[_c('div',{staticClass:"toggle-pill-container"},_vm._l((_vm.options),function(option,index){return _c('button',{key:option.value,staticClass:"toggle-pill-btn",class:{
        active: _vm.value === option.value,
        'first': index === 0,
        'last': index === _vm.options.length - 1
      },on:{"click":function($event){return _vm.$emit('input', option.value)}}},[_vm._v(" "+_vm._s(option.text)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }